module.exports = __webpack_public_path__ + "img/banker-outline.d4bea54e.svg";